module.exports = __webpack_public_path__ + "static/img/0545_2.b89b82a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0545_2.jpg
// module id = bFgg
// module chunks = 1